import { Form } from 'react-bootstrap';
import { FieldHookConfig, useField } from 'formik';

interface OtherProps {
  label: string;
  options: any[];
  onChange: (e: React.ChangeEvent<any>) => void;
}

export default function SelectInput(
  props: OtherProps & FieldHookConfig<string>
) {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField({ ...props });

  return (
    <>
      <Form.Label className="ec-modal-label">{props.label}</Form.Label>
      <Form.Control
        as="select"
        className="ec-modal-select"
        {...field}
        name={props.name}
        autoComplete={props.autoComplete}
        onChange={(e) => props.onChange(e)}
      >
        {props.options.map((option, i) => {
          return <option key={option}>{option}</option>;
        })}
      </Form.Control>
      <Form.Text className="ec-modal-error-msg">
        {meta.touched && meta.error ? (
          // <div className="error">{meta.error}</div>
          <>{meta.error}</>
        ) : null}
      </Form.Text>
    </>
  );
}
